import script from "./ProductCardPricesInternet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardPricesInternet.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardPricesInternet.vue?vue&type=style&index=0&id=a88f8e70&lang=scss"

const __exports__ = script;

export default __exports__